(() => {
  const dragState = new WeakMap();

  const setupDragScroll = (scroller) => {
    if (scroller.dataset.learnDragReady === 'true') return;
    scroller.dataset.learnDragReady = 'true';

    scroller.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragState.set(scroller, {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScroll: scroller.scrollLeft,
        moved: false
      });
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', (event) => {
      const state = dragState.get(scroller);
      if (!state || state.pointerId !== event.pointerId) return;
      const distance = event.clientX - state.startX;
      if (Math.abs(distance) > 4) state.moved = true;
      scroller.scrollLeft = state.startScroll - distance;
    });

    const finish = (event) => {
      const state = dragState.get(scroller);
      if (!state || state.pointerId !== event.pointerId) return;
      if (scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
      scroller.classList.remove('is-dragging');
      dragState.delete(scroller);
      if (state.moved) {
        scroller.dataset.suppressClick = 'true';
        requestAnimationFrame(() => delete scroller.dataset.suppressClick);
      }
    };

    scroller.addEventListener('pointerup', finish);
    scroller.addEventListener('pointercancel', finish);
    scroller.addEventListener('click', (event) => {
      if (scroller.dataset.suppressClick === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  };

  const setupArticleTables = (scope) => {
    scope.querySelectorAll('.cl-learn-article__rte table').forEach((table) => {
      if (table.parentElement?.classList.contains('cl-learn-article__table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'cl-learn-article__table-scroll';
      wrapper.setAttribute('tabindex', '0');
      table.before(wrapper);
      wrapper.append(table);
    });
  };

  const setupStickyCta = (cta) => {
    if (cta.dataset.learnStickyReady === 'true') return;
    cta.dataset.learnStickyReady = 'true';
    const threshold = Math.min(90, Math.max(10, Number(cta.dataset.learnStickyPercent) || 50));
    let frame = 0;

    const update = () => {
      frame = 0;
      const page = document.scrollingElement || document.documentElement;
      const available = Math.max(1, page.scrollHeight - window.innerHeight);
      const visible = (window.scrollY / available) * 100 >= threshold;
      cta.classList.toggle('is-visible', visible);
      cta.toggleAttribute('inert', !visible);
      cta.setAttribute('aria-hidden', String(!visible));
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  };

  const removeEmptyParagraphs = (scope) => {
    scope.querySelectorAll('.cl-learn-article__rte p').forEach((paragraph) => {
      const isEmpty = paragraph.textContent.replace(/\u00a0/g, ' ').trim() === ''
        && !paragraph.querySelector('img, video, iframe, svg, input, button');
      if (isEmpty) paragraph.remove();
    });
  };

  const initialize = (scope = document) => {
    removeEmptyParagraphs(scope);
    setupArticleTables(scope);
    scope.querySelectorAll('[data-learn-drag-scroll]').forEach(setupDragScroll);
    scope.querySelectorAll('[data-learn-sticky-cta]').forEach(setupStickyCta);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
